import { z } from 'zod';
import { DataGridViewType, metricColoringValidator } from '@/features/DataGrid';
import type { Filters } from '@/features/filters';
import { filtersValidator } from '@/features/filters';
import type { SerializedDateRangeValueObject, Sorting } from '@/shared/types';
import {
  DateScale,
  Lifetime,
  columnsWidthStateValidator,
  serializedDateRangeValueObjectValidator,
  sortingValidator,
} from '@/shared/types';

export interface MarketingPerformanceDataPage {
  rows: Record<string, string | number>[];
  hasNextPage: boolean;
}

export type TreeDataRow = { path: string[] } & Record<string, string | number>;

export const dataConfigValidator = z.object({
  dimensions: z.array(z.string()),
  metrics: z.array(z.string()),
  dateScale: z.nativeEnum(DateScale),
  dateRange: serializedDateRangeValueObjectValidator,
  sorting: sortingValidator,
  lifetime: z.nativeEnum(Lifetime),
  probabilisticAttribution: z.boolean(),
  filters: filtersValidator,
  rowHeight: z.number(),
  columnsWidth: columnsWidthStateValidator,
  metricsColoring: z.array(metricColoringValidator).optional(),
  dataGridViewType: z.nativeEnum(DataGridViewType),
});

export type DataConfig = z.infer<typeof dataConfigValidator>;

export interface GetDataParams {
  dimensions: string[];
  dateScale: DateScale;
  dateRange: SerializedDateRangeValueObject;
  sorting: Sorting;
  probabilisticAttribution: boolean;
  lifetime: Lifetime;
  filters: Filters;
  offset?: number;
  pageSize?: number;
}
export interface GetMetricsMinMaxParams {
  dimensions: string[];
  metrics: string[];
  filters: Filters;
  dateRange: SerializedDateRangeValueObject;
  dateScale: DateScale;
  probabilisticAttribution: boolean;
  lifetime: number;
}

export interface GetTotalParams {
  dimensions: string[];
  metrics: string[];
  filters: Filters;
  dateRange: SerializedDateRangeValueObject;
  probabilisticAttribution: boolean;
  lifetime: number;
}

export interface DataUpdateInfo {
  updateTime: string;
}
